<h3>Did you watch in the wrong order?</h3>
<div class="container">
    <canvas #canvas></canvas>
    <div class="title">{{ seriesName }}</div>
</div>